angular.module("notePreventivo.components", [])
    .component("notePreventivo", {
        templateUrl: "ng/components/monitorPratica/notePreventivo/notePreventivo.view.html",
        bindings: {
            listaNote: "<",
            model: '<',
            addNotes: '&',
            watchRest: '<'
        },
        controllerAs: "notePreventivoCtrl",
        controller: function NotePreventivo(
            $modalService,
            $typeDomainService
        ) {
            var self = this;

            self.$onInit = function () {
            };

            self.noteToAdd = {
                tipoNota: undefined,
                nota: undefined
            }

            self.addNote = function () {
                $modalService.openModal("aggiungiNotaModal");
                getCodTypeNote()
            }

            self.closeModal = function () {
                self.noteToAdd = undefined;
                $modalService.closeModal("aggiungiNotaModal");
            }

            var getCodTypeNote = function () {
                self.loaderTipi = true;
                $typeDomainService.getCodTypeNote(self.model.id)
                    .then(function (response) {
                        self.listaTipi = response.listUniType
                        self.loaderTipi = false;
                    })
                    .catch(function (err) {
                        console.log(err)
                        self.loaderTipi = false;
                    })
            }

            self.sendNote = function () {
                var noteToAdd = {
                    tipoNota: self.noteToAdd.tipoNota.description,
                    nota: self.noteToAdd.nota
                }
                self.loaderNota = true;
                $typeDomainService.insertNote(self.model.id, self.noteToAdd.tipoNota.value, self.noteToAdd.nota)
                    .then(function (response) {
                        self.loaderNota = false;
                        if (response.success) {
                            $modalService.closeModal("aggiungiNotaModal");
                            self.addNotes()
                            self.noteToAdd = undefined;
                        }
                    }).catch(function (err) {
                        self.loaderNota = false;
                        console.log(err)
                    })
            }
        }
    });